var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.migrateList.length
    ? _c(
        "form",
        {
          attrs: { novalidate: "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-main" },
            [
              _c("h3", [_vm._v("Migrate Children")]),
              _vm._v(" "),
              _c("select-box", {
                attrs: {
                  label: "Migrate to",
                  "data-list": _vm.migrateList,
                  "format-callback": function(item) {
                    return item.name
                  }
                },
                on: { selected: _vm.onSelect }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-footer" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "spinner",
                    rawName: "v-spinner",
                    value: _vm.isLoading,
                    expression: "isLoading"
                  }
                ],
                staticClass: "primary-btn btn-center",
                attrs: {
                  disabled:
                    !_vm.formValid || _vm.formPristine || !_vm.form.newId
                }
              },
              [_vm._v("\n                Submit\n            ")]
            )
          ])
        ]
      )
    : _c(
        "div",
        {
          staticClass: "not-found my-0 mx-4 text-center",
          style: { height: "85%" }
        },
        [
          _c("img", {
            style: { height: "250px", marginBottom: "25px" },
            attrs: { src: require("../../assets/img/empty.png") }
          }),
          _vm._v("\n        Oh no! You haven't another active options.\n    ")
        ]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70ebe34c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ebe34c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MigrateChildrenModal.vue
// module id = null
// module chunks = 